"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _propTypes = require("prop-types");

var _constant = require("../Theme/constant");

var _constant2 = require("./constant");

var contentType = (0, _propTypes.oneOfType)([_propTypes.string, (0, _propTypes.shape)({
  icon: _propTypes.string,
  translationKey: _propTypes.string
})]);
var _default = {
  PropTypes: {
    accessible: _propTypes.bool,
    theme: _propTypes.string,
    baggageType: _propTypes.string.isRequired,
    baggageHeadingColor: (0, _propTypes.oneOf)(_constant.ARR_COLORS).isRequired,
    baggageTypeColor: (0, _propTypes.oneOf)(_constant.ARR_BACKGROUND_COLORS).isRequired,
    translation: (0, _propTypes.shape)({
      handCarry: _propTypes.string,
      checkBaggage: _propTypes.string,
      toolTipTitle: _propTypes.string,
      toolTipLabel: _propTypes.string
    }),
    showToolTip: _propTypes.bool.isRequired,
    toolTipColor: (0, _propTypes.oneOf)([].concat((0, _toConsumableArray2.default)(_constant.ARR_COLORS), [''])).isRequired,
    isMobile: _propTypes.bool,
    customToolTipContent: _propTypes.element,
    toolTipTitle: _propTypes.string.isRequired,
    toolTipContent: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
      type: (0, _propTypes.oneOf)(Object.keys(_constant2.TOOLTIP_CONTENT_TYPE)).isRequired,
      content: (0, _propTypes.arrayOf)(contentType),
      ctaText: _propTypes.string,
      ctaLink: _propTypes.string
    }))
  },
  DefaultProps: {
    accessible: false,
    theme: _constant.DEFAULT_THEME,
    baggageType: '',
    baggageHeadingColor: 'black',
    baggageTypeColor: 'default',
    showToolTip: false,
    translation: _constant2.TRANSLATION,
    toolTipColor: 'secondaryBlue',
    isMobile: false,
    toolTipTitle: '',
    toolTipContent: []
  }
};
exports.default = _default;